import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter, Routes } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/feed',
        pathMatch: 'full' as const
    },
    {
        path: 'feed',
        loadComponent: () => import('./app/pages/feed/feed.component').then(m => m.FeedComponent)
    },
    {
        path: 'feed/:city',
        loadComponent: () => import('./app/pages/feed/feed.component').then(m => m.FeedComponent)
    },
    {
        path: 'business',
        loadComponent: () => import('./app/pages/home/home.component').then(m => m.HomeComponent)
    },
    {
        path: '**',
        redirectTo: '/feed'
    }
];

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideHttpClient(),
        importProvidersFrom(FormsModule)
    ]
}).catch(err => console.error(err));
